import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useContent } from "../context/ContentContext";
import PortfolioCard from "../components/PortfolioCard";
import Lightbox from "../components/Lightbox";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Portfolio() {
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [filter, setFilter] = useState("All");
  const [lightboxIdx, setLightboxIdx] = useState(-1);
  const { content } = useContent();
  const pp = content.portfolio_page || {};

  useEffect(() => {
    axios.get(`${API}/portfolio`).then((r) => setItems(r.data)).catch(() => {});
    axios.get(`${API}/portfolio-categories`).then((r) => setCats(r.data || [])).catch(() => {});
  }, []);

  const categories = useMemo(() => ["All", ...cats.map((c) => c.name)], [cats]);
  const filtered = useMemo(() => filter === "All" ? items : items.filter((i) => i.category === filter), [items, filter]);

  return (
    <div data-testid="portfolio-page">
      <section className="grain-coral border-b-2 border-ink relative overflow-hidden">
        <div className="relative z-10 mx-auto max-w-7xl px-5 py-16 md:py-24 md:px-10">
          <p className="eyebrow text-ink text-xs">{pp.eyebrow || "Portfolio"}</p>
          <h1 className="heading mt-3 text-4xl md:text-6xl text-ink">{pp.headline || "The work, on the record."}</h1>
          <p className="mt-5 max-w-2xl text-lg text-ink/90">{pp.intro || "A loose collection of recent faces — bridal, editorial, events, hair and a few moments from set."}</p>
        </div>
      </section>

      <section className="bg-cream border-b-2 border-ink">
        <div className="mx-auto max-w-7xl px-5 py-10 md:py-12 md:px-10">
          <div className="flex flex-wrap gap-3" role="tablist" aria-label="Filter portfolio">
            {categories.filter(Boolean).map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className={`eyebrow text-[0.7rem] px-4 py-2 border-2 border-ink transition-all ${filter === c ? 'bg-ink text-cream shadow-brutSm' : 'bg-cream text-ink hover:bg-coral'}`}
                data-testid={`portfolio-filter-${(c||'').toLowerCase().replace(/\s|&/g,'')}`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-cream">
        <div className="mx-auto max-w-7xl px-5 py-12 md:py-16 md:px-10">
          {filtered.length === 0 ? (
            <p className="text-center text-ink/70 py-20">{pp.empty_message || "No looks in this category yet. Stay tuned."}</p>
          ) : (
            <div className="masonry">
              {filtered.map((p, idx) => (
                <PortfolioCard key={p.id} item={p} idx={idx} onClick={() => setLightboxIdx(idx)} />
              ))}
            </div>
          )}
        </div>
      </section>
      {lightboxIdx >= 0 && (
        <Lightbox items={filtered} index={lightboxIdx} onChange={setLightboxIdx} onClose={() => setLightboxIdx(-1)} />
      )}
    </div>
  );
}
